import _ from 'lodash'
import managerService from '@/API/managerService'
import { reqComplainList } from '@/api/customerComplain'
import {
  SET_MANAGER_LIST,
  SET_BACKUP_MANAGER_INFO,
  SET_SELECTED_MANAGER_INFO,
  SET_SELECTED_MANAGER_DEPARTMENT,
  SET_SELECTED_MANAGER_EMAIL,
  SET_SELECTED_MANAGER_NOTE,
  SET_SELECTED_MANAGER_PHONE,
  SET_SELECTED_MANAGER_POSITION_ID,
  SET_SELECTED_MANAGER_NUMBER,
  SET_COMPLAIN_LIST,
  SET_PAGING,
  SET_IS_SEARCH_BTN_LOADING,
  SET_CURRENT_LOGIN_SERVICE_ID,
  SET_IS_TABLE_LOAGING,
  SET_CURRENT_PAGE,
} from './mutation-types'
import { cookies } from '@/utils/cookies'

export default {
  fetchManagerList({ commit }) {
    return managerService
      .getManagerList()
      .then((res) => res.result)
      .then((result) => result.sort((a, b) => a.id - b.id))
      .then((result) => {
        commit(SET_MANAGER_LIST, result)
        /* 將目前登入客服的id放到vuex store */
        const currentServiceName = cookies.get('GladName')
        const currentManagerInfo = result.find(
          (manager) => manager.managerName === currentServiceName,
        )
        if (currentManagerInfo) {
          commit(SET_CURRENT_LOGIN_SERVICE_ID, currentManagerInfo.id)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  fetchManagerInfo({ dispatch }, id) {
    return managerService
      .getManagerInfo(id)
      .then((res) => res.result)
      .then((result) => {
        dispatch('setSelectedManagerInfo', _.cloneDeep(result))
        dispatch('setBackupManagerInfo', _.cloneDeep(result))
        return result
      })
      .catch((err) => console.log(err))
  },
  async fetchComplainList({ state, commit }, type = null) {
    commit(SET_IS_SEARCH_BTN_LOADING, true)
    commit(SET_IS_TABLE_LOAGING, true)
    try {
      const { driverId, typeId, managerId, teamCode, start, end, status } =
        state.searchForm
      /* 若是封存客服事件後重新提取列表，須注意是否封存了該頁的最後一筆紀錄*/
      let currentPage = state.paging.currentPage
      if (
        state.paging.totalPages > 1 &&
        state.complainList.length === 1 &&
        type === 'afterDelete'
      ) {
        currentPage -= 1
      }
      /* 若是新增客服事件後重新提取列表，預設頁面跳轉回第一頁 */
      if (type === 'afterAdd') {
        currentPage = 1
        commit(SET_CURRENT_PAGE, 1)
      }
      const params = {
        code: teamCode,
        start: start,
        end: end,
        status: status,
        driver_id: driverId,
        type_id: typeId,
        customer_id: managerId,
        current_page: currentPage,
        per_page: state.paging.perPage,
      }
      const { complaint, paging } = await reqComplainList(params)
      commit(SET_COMPLAIN_LIST, complaint)
      commit(SET_PAGING, paging)
    } catch (e) {
      throw e
    } finally {
      commit(SET_IS_SEARCH_BTN_LOADING, false)
      commit(SET_IS_TABLE_LOAGING, false)
    }
  },
  putSelectedManagerInfo({ getters, dispatch }, id) {
    return managerService
      .updateUserInfo(id, getters.getSelectedManagerInfo)
      .then((res) => {
        dispatch(
          'setBackupManagerInfo',
          _.cloneDeep(getters.getSelectedManagerInfo),
        )
        return res
      })
      .catch((err) => err)
  },
  setSelectedManagerInfo({ commit }, managerInfo) {
    commit(SET_SELECTED_MANAGER_INFO, managerInfo)
  },
  setBackupManagerInfo({ commit }, managerInfo) {
    commit(SET_BACKUP_MANAGER_INFO, managerInfo)
  },
  restoreSelectedManagerInfo({ dispatch, state }) {
    dispatch('setSelectedManagerInfo', _.cloneDeep(state.backupManagerInfo))
  },
  setSelectedManagerDepartment({ commit }, department) {
    commit(SET_SELECTED_MANAGER_DEPARTMENT, department)
  },
  setSelectedManagerEmail({ commit }, email) {
    commit(SET_SELECTED_MANAGER_EMAIL, email)
  },
  setSelectedManagerNote({ commit }, note) {
    commit(SET_SELECTED_MANAGER_NOTE, note)
  },
  setSelectedManagerPhone({ commit }, phone) {
    commit(SET_SELECTED_MANAGER_PHONE, phone)
  },
  setSelectedManagerPositionId({ commit }, positionId) {
    commit(SET_SELECTED_MANAGER_POSITION_ID, positionId)
  },
  setSelectedManagerServiceNumber({ commit }, serviceNumber) {
    commit(SET_SELECTED_MANAGER_NUMBER, serviceNumber)
  },
}



// WEBPACK FOOTER //
// ./src/store/managerStore/actions.js